/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Donate.css";
import logo from "./unnamed (1).png";
import { useConfig } from "../../context/ConfigContext";

export default function STGilesDonate() {
  const { config } = useConfig();
  const API_URL = config.REACT_APP_API_URL;
  const API_KEY = config.REACT_APP_API_KEY;

  const [amount, setAmount] = useState(0);
  const [displayAmount, setDisplayAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const revealRef = useRef([]);

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const res = await fetch(API_URL, {
          headers: { "Api-Key": API_KEY },
        });
        const data = await res.json();
        const total =
          Number(
            data?.donated?.amountDonated ??
              data?.amount ??
              data?.donatedAmount ??
              0
          ) || 0;
        setAmount(total);
        setDisplayAmount(total);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(true);
        setLoading(false);
      }
    };

    fetchAmount();
  }, [API_URL, API_KEY]);

  useEffect(() => {
    if (!loading && !error) {
      let start = 0;
      const duration = 3000;
      const end = amount;
      const stepTime = 16;
      const increment = (end - start) / (duration / stepTime);
      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(counter);
        }
        setDisplayAmount(Math.round(start));
      }, stepTime);
      return () => clearInterval(counter);
    }
  }, [loading, error, amount]);

  useEffect(() => {
    const els = revealRef.current;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("show");
      });
    }, { threshold: 0.15 });
    els.forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section className="donations-page">
      <div className="header">
        <h1>Support St Giles Animal Welfare</h1>
        <p className="intro">Together we honour Beth by helping animals receive safety, care, and the chance to find a loving home.</p>
      </div>

      <div className="cards">
        <article className="card reveal" ref={(el) => (revealRef.current[0] = el)}>
          <h2 className="box-header">About St Giles</h2>
          <p>
Based in Taunton and serving Somerset and Devon, St Giles Animal Welfare gives abandoned, abused and displaced pets a second chance at a loving home. But their work extends far beyond rehoming. They run education and enrichment programmes for local children and young people, offer a pet food bank, and engage the community through volunteering and events. Your support for the memorial match helps fuel all of this amazing work, it means more happy “forever homes,” more community impact, and more lives changed (both human and animal).  
          </p>
        </article>

        <article className="card reveal" ref={(el) => (revealRef.current[1] = el)}>
          <h2 className="box-header">How Your Donations Help</h2>
          <ul className="help-list">
            <li>Giving frightened, abandoned animals a lifeline, making sure they receive the urgent medical care they need the moment they arrive.</li>
            <li>Helping traumatised pets learn to trust again, funding the gentle rehabilitation that turns fear into hope.</li>
            <li>Keeping families and their beloved pets together, by supporting the St Giles pet food bank during the hardest moments of people’s lives.</li>
            <li>Creating safer, warmer spaces for every dog and cat who comes through their doors, so they feel protected while they wait for their forever home.</li>
            <li>Supporting the Beth Branson Education Hub, inspiring children to care for animals with compassion, patience and kindness — values Bethany held so fiercely.</li>
            <li>Allowing the rescue team to reach animals in crisis, no matter how tough the situation.</li>
            <li>Giving every animal the chance of a new beginning, and every family the joy of welcoming a much-needed friend home.</li>
          </ul>
          <div className="cta-row">
            <Link to="https://square.link/u/wcHJPHfK?src=sheet" target="_blank" rel="noreferrer" className="btn donate">Donate Now</Link>
          </div>
        </article>

        <article className="card total reveal" ref={(el) => (revealRef.current[2] = el)}>
          <h2 className="box-header">Total Raised</h2>
          {loading && <p className="faded">Loading total…</p>}
          {error && <p className="faded error">Unable to load the total right now.</p>}
          {!loading && !error && (
            <p className="amount">£{displayAmount.toLocaleString()}</p>
          )}
          <p className="note">Thank you for every single donation — your support keeps Beth’s legacy alive.</p>
          <img src={logo} alt=""></img>
        </article>
      </div>
    </section>
  );
}